import BaseModel from './BaseModel';

export default class PdfFileModel extends BaseModel {
  init(data) {
    this.title = data.title || '';
    this.download_url = data.download_url || '';
    this.embed_url = data.embed_url || '';
  }
}
